import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const FormSwitchInputElementFields = {
  group: ELEMENT_GROUPS.FORMS,
  label: 'Form Switch Input',
  icon: 'DocumentTextIcon',
  description: 'Adds a switch input form control',
  properties: [
    'layout',
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description:
        'Choose a data source that this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the value of this element',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'element.datasourceId']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Default Value',
      name: 'defaultValue',
      editor: 'switch',
      description: 'Default value',
      default: false,
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Label Left',
      name: 'labelLeft',
      editor: 'textbox',
      description: 'The false value label',
      default: 'No',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Value Left',
      name: 'valueLeft',
      editor: 'textbox',
      description: 'The false value',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Label Right',
      name: 'labelRight',
      editor: 'textbox',
      description: 'The true value label',
      default: 'Yes',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Value Right',
      name: 'valueRight',
      editor: 'textbox',
      description: 'The true value',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      name: 'color',
      label: 'Thumb Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#ffffff',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'backgroundColorOn',
      label: 'Background Color On',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#182fa4',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'backgroundColorOff',
      label: 'Background Color Off',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#a0aec0',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    'alignment',
    {
      label: 'Margin',
      name: 'margin',
      editor: 'boundary',
      description: 'The margin around the input',
      default: '10 0 10 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },

    'padding'
  ]
};

export default FormSwitchInputElementFields;
